import React from "react";
import { Container } from "../../styles/globalStyles";
import { StyledImg } from "../../styles/styledComponents";

const SideContainer = ({ left, right }) => {
  return (
    <Container
      flex={1}
      jc={"center"}
      ai={"center"}

    >
      <StyledImg
        alt={"kungfu-koala-img"}
        src={
          left
            ? "/config/images/left-side.jpeg"
            : "/config/images/right-side.jpeg"
        }
      />
    </Container>
  );
};

export default SideContainer;
